import type { UndecoratedFormField } from '@witmetrics/utils';
import { buildOption } from '@witmetrics/unison-core';
import { isJson } from '@witmetrics/utils/strings';

export function getSelectValues(field: UndecoratedFormField, value: string) {
  return { currentOption: buildOption(value), options: getOptions(field) };
}

export function getCheckboxValues(field: UndecoratedFormField, value: string) {
  const parsedValue: string[] = isJson(value) ? JSON.parse(value) : [];
  return {
    currentOptions: parsedValue.map((v) => buildOption(v)),
    options: getOptions(field),
  };
}

function getOptions(field: UndecoratedFormField) {
  return (field.settings?.acceptedValues || []).map((item) =>
    buildOption<string>(item)
  );
}
